import { changeOnlyFirstLetterToCapital } from '@tcp/core/src/utils/utils';
import { renderLabel, getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';

const useStoreText = (storeData, bopisFilterLabels) => {
  const storeText = `At ${changeOnlyFirstLetterToCapital(
    storeData?.basicInfo?.storeName
  )}, ${changeOnlyFirstLetterToCapital(storeData?.basicInfo?.address?.city)}`;

  let storeChangeText = bopisFilterLabels?.lbl_plp_select_store;
  let storeSelectionMessage = bopisFilterLabels?.lbl_plp_select_nearby_store;

  if (storeData?.basicInfo?.id) {
    storeChangeText = storeText;
    storeSelectionMessage = renderLabel(
      getDynamicLabelValues('dynamic.browse_d.lbl_free_one_hr_pickup'),
      'lbl_free_one_hr_pickup'
    );
  }

  return { storeChangeText, storeSelectionMessage };
};

export default useStoreText;
